/**
 * 메인: 베스트상품 목록
 *
 *
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
//import { strCut, stringToMoneyFormat } from 'utils';
import { Content, Title, Button, ProductItem } from 'components';
import { RightOutlined } from '@ant-design/icons';
//import Product from 'assets/product_01.png';
//import { ProductApi } from 'api';
import { encrypt } from 'utils/Crypto';
import { Empty } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인 > 베스트상품 컴포넌트
 * ----------------------------------------
 */
const BestSellers = ({ products = [], slides = [], giftTabs, screenSize }) => {
  /* ===== INIT ===== */
  const navigate = useNavigate();

  /* ===== STATE ===== */
  const [bestList, setBestList] = React.useState([]);
  const [tabs, setTabs] = React.useState([]);

  const [progress, setProgress] = useState(0);

  /* 스크롤 그라데이션 */
  const containerRef = React.useRef(null);
  const [hasScroll, setHasScroll] = useState(false);
  const [leftOpacity, setLeftOpacity] = useState(0); // 왼쪽 그라데이션 투명도
  const [rightOpacity, setRightOpacity] = useState(1); // 오른쪽 그라데이션 투명도

  // const tabs = [
  //   '스페셜티 블렌드',
  //   '싱글 오리진',
  //   '커피티백',
  //   '더치커피',
  //   '커피용품',
  //   '굿즈',
  //   '선물세트',
  // ];
  const [selected, setSelected] = useState(tabs[0]);

  useEffect(() => {
    const currentContainer = containerRef.current;

    const checkScroll = () => {
      if (currentContainer) {
        const { scrollWidth, clientWidth, scrollLeft } = containerRef.current;

        const isScrollable = scrollWidth > clientWidth;
        setHasScroll(isScrollable);

        // 왼쪽 & 오른쪽 스크롤 여부 감지하여 opacity 조절
        setLeftOpacity(scrollLeft === 0 ? 0 : 1);
        setRightOpacity(scrollLeft + clientWidth >= scrollWidth ? 0 : 1);
      }
    };

    checkScroll(); // 최초 실행

    currentContainer?.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    return () => {
      currentContainer?.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, [tabs, screenSize]);
  /* ===== VARIABLE ===== */

  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
      lineHeight: screenSize >= 768 ? '88px' : '150%',
      marginBottom: screenSize >= 500 ? 0 : 20,
      paddingRight: 10,
    },
    subTitle: {
      fontSize: 18,
      fontWeight: 400,
      lineHeight: '30px',
      color: 'var(--black-color)',
    },

    mainFlexContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    bullet: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      border: '3px solid var(--black-color)',
      display: 'inline-block',
      marginRight: 12,
      cursor: 'pointer',
    },
  };

  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */
  React.useEffect(() => {
    if (!products?.length) return;
    const best = products?.filter((item) => item.isBest === 'Y');

    const divBest = best.reduce(
      (acc, cur) => {
        const { category, categoryTitle } = cur;

        if (!acc.categories[category]) {
          acc.categories[category] = categoryTitle;
        }

        acc.products.push(cur);
        return acc; // 반드시 누적값 반환
      },
      { products: [], categories: {} },
    );

    setBestList(divBest?.products);
    const categoryList = Object.entries(divBest?.categories)?.map(
      ([key, value]) => ({
        value: key,
        label: value,
      }),
    );
    setTabs(categoryList);
  }, [products]);

  useEffect(() => {
    const totalSlides = bestList.filter(
      (item) => item.category === selected,
    ).length;
    const visibleSlides = screenSize >= 1000 ? 4 : screenSize >= 700 ? 3 : 2;
    if (totalSlides > 0) {
      setProgress(0);
    }
    const maxProgress =
      totalSlides <= visibleSlides ? 100 : (visibleSlides / totalSlides) * 100;
    setProgress(maxProgress);

    if (totalSlides > 0) {
      setProgress(maxProgress);
    }

    // eslint-disable-next-line
  }, [selected, bestList]);

  /* ===== RENDER ===== */
  React.useEffect(() => {
    if (!tabs.length) return;

    setSelected(tabs?.[0]?.value);
  }, [tabs]);

  // JSX: start
  return (
    <div>
      {/* === === */}
      <Content
        maxWidth={1500}
        padding={0}
        style={{
          marginTop: screenSize >= 768 ? 100 : 0,
          margin: '0 auto',
        }}
        className="bestsellers main_swiper"
      >
        <Title
          style={{ ...styles.title, flexWrap: 'wrap' }}
          className="dela-gothic"
          subButton={
            <Button
              onClick={() => navigate(`/products?type=best&page=1`)}
              style={{
                fontSize: screenSize >= 768 ? 16 : 13,
                padding: screenSize >= 768 ? '8px 30px' : '4px 10px',
                minWidth: 82,
                //backgroundColor: 'var(--white-color)',
                //color: 'var(--black-color)',
              }}
              className={'goto'}
            >
              바로가기 <RightOutlined />
            </Button>
          }
        >
          Coffee
        </Title>
        {/* === 카테고리 === */}
        {/* <Tabs
          items={giftTabs}
          fullscreen={false}
          layoutStyle={{ border: 'none' }}
          style={{
            fontSize: 24,
            padding: 0,
            marginRight: 40,
            marginTop: 60,
          }}
          textStyle={{
            fontFamily: `${'Dela Gothic One'}, sans-serif`,
            padding: 2,
            lineHeight: '38px',
          }}
          activeColor={'var(--black-color)'}
        /> */}

        {/* === 탭 === */}
        <div
          className="button_wrap"
          style={{
            position: 'relative',
          }}
        >
          {/* 좌측 그라데이션 */}
          {hasScroll && (
            <div
              style={{
                position: 'absolute',
                width: 25,
                height: '100%',
                top: 0,
                left: 0,
                background:
                  'linear-gradient(to right, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)',
                zIndex: 3,
                opacity: leftOpacity,
                transition: 'opacity 0.3s ease-in-out',
                pointerEvents: 'none',
              }}
            />
          )}
          <div
            ref={containerRef}
            style={{
              width: '100%',
              overflowX: 'auto',
              display: 'flex',
              flexDirection: 'row',
              gap: screenSize >= 768 ? 20 : 10,
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {tabs.map((tab) => (
              <Button
                key={tab.value}
                className={selected === tab.value ? '' : 'unsellected'}
                onClick={() => setSelected(tab.value)}
              >
                {tab.label}
              </Button>
            ))}
          </div>
          {/* 우측 그라데이션 */}
          {hasScroll && (
            <div
              style={{
                position: 'absolute',
                width: 25,
                height: '100%',
                top: 0,
                right: 0,
                background:
                  'linear-gradient(to left, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)',
                zIndex: 3,
                opacity: rightOpacity,
                transition: 'opacity 0.3s ease-in-out',
                pointerEvents: 'none',
              }}
            />
          )}
        </div>

        {/* ==== 상품목록 수정 ==== */}
        <Swiper
          slidesPerView={screenSize >= 1000 ? 4 : screenSize >= 700 ? 3 : 2}
          spaceBetween={screenSize >= 1000 ? 20 : 15}
          modules={[Navigation]}
          loop={false}
          navigation
          onSlideChange={(swiper) => {
            if (swiper.activeIndex === 0) setProgress(0);
            const totalSlides = swiper.slides.length;
            const visibleSlides = swiper.params.slidesPerView;
            const currentProgress =
              (swiper.activeIndex + visibleSlides) / totalSlides;
            const maxProgress =
              totalSlides <= visibleSlides
                ? 100
                : Math.max(0, currentProgress * 100);
            setProgress(Math.min(100, maxProgress));
          }}
          style={{
            minHeight:
              screenSize >= 1600 ? 690 : screenSize >= 400 ? '40vw' : '95vw',
          }}
        >
          {bestList
            .filter((item) => item.category === selected)
            .map((_item, _index) => (
              <SwiperSlide key={`product_${_index}`}>
                <div
                  onClick={() =>
                    navigate(
                      `/products/${encodeURIComponent(encrypt(_item.key))}`,
                    )
                  }
                >
                  <ProductItem
                    src={_item.src}
                    title={_item.title}
                    price={_item.price}
                    discount={_item.discount}
                    discountType={_item.discount_type}
                    // review={_item.review_count}
                    // tags={_item.tag}
                    hovered={false}
                    brand={_item.brand}
                    titleStyle={{ marginTop: 10 }}
                    isSoldOut={_item.isSoldOut === 'Y' ? true : false}
                    policies={_item.policies}
                    icons={[
                      {
                        label: 'BEST',
                        color: 'rgb(202, 97, 98)',
                      },
                      ...(_item.isNew === 'Y'
                        ? [
                            {
                              label: 'NEW',
                              color: 'rgb(56, 56, 56)',
                            },
                          ]
                        : []),
                    ]}
                  />
                  <ProductItem.Review
                    review={{ score: _item.score, comment: _item.comment }}
                    style={{ marginTop: 16 }}
                  />
                  <ProductItem.Tags
                    tags={_item.tags.map((tag) => ({
                      id: tag.tag_id,
                      label: tag.label,
                    }))}
                    style={{ marginBottom: 4 }}
                  />
                </div>
              </SwiperSlide>
            ))}
        </Swiper>

        <div
          style={{
            width: '100%',
            height: '7px',
            backgroundColor: '#ddd',
            borderRadius: 15,
            marginTop: screenSize >= 1800 ? 0 : 20,
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: '100%',
              backgroundColor: 'var(--black-color)',
              transition: 'width 0.3s ease-in-out',
              borderRadius: 15,
            }}
          />
        </div>

        {bestList.filter((item) => item.category === selected).length === 0 && (
          <Empty style={{ width: '100%' }} />
        )}

        {/* === 상품목록(스크롤) === */}
        {/* <div
          className="custom-scroll"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            overflowX: 'auto',
            padding: '12px 0 24px',
            height: 'fit-content',
            minHeight: screenSize >= 768 ? 700 : 'auto',
          }}
        >
          {
            // productList
            bestList.length ? (
              bestList
                ?.filter((item) => item.category === selected)
                ?.map((_item, _index) => (
                  <div
                    key={`product_${_index}`}
                    style={{
                      width: screenSize >= 768 ? 365 : '45vw',
                      minWidth: 200,
                      marginRight: 12,
                      padding: '2.5px 5px',
                      flexShrink: 0,
                    }}
                    onClick={() =>
                      navigate(
                        `/products/${encodeURIComponent(encrypt(_item.key))}`
                      )
                    }
                  >
                    <ProductItem
                      src={_item.src}
                      title={_item.title}
                      price={_item.price}
                      discount={_item.discount}
                      discountType={_item.discount_type}
                      // review={_item.review_count}
                      // tags={_item.tag}
                      hovered={false}
                      brand={_item.brand}
                      titleStyle={{ marginTop: 10 }}
                      isSoldOut={_item.isSoldOut === 'Y' ? true : false}
                      icons={[
                        {
                          label: 'BEST',
                          color: 'rgb(202, 97, 98)',
                        },
                        ...(_item.isNew === 'Y'
                          ? [
                              {
                                label: 'NEW',
                                color: 'rgb(56, 56, 56)',
                              },
                            ]
                          : []),
                      ]}
                    />
                    <ProductItem.Review
                      review={{ score: _item.score, comment: _item.comment }}
                      style={{ marginTop: 16 }}
                    />
                    <ProductItem.Tags
                      tags={_item.tags.map((tag) => ({
                        id: tag.tag_id,
                        label: tag.label,
                      }))}
                      style={{ marginBottom: 4 }}
                    />
                  </div>
                ))
            ) : (
              <Empty style={{ width: '100%' }} />
            )
          }
        </div> */}
      </Content>

      {/* === === */}
    </div>
  ); // JSX: end
};

/* DF */
BestSellers.defaultProps = {
  products: [],
  giftTabs: [],
};

export default BestSellers;
